import api from '../callApi';

const completeTweet = (apiRequestData, actionCompletedTime) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime: actionCompletedTime
    };

    return api.post('Widget/CompleteTweetAsync', request).then(response => {
        return response;
    });
};

export default completeTweet;



// WEBPACK FOOTER //
// ./src/utils/tweet/tweetApi.js